import React, { Component } from 'react';
import RatingCheckbox from './rating-checkbox';

class Rating extends Component {
  render() {
    const { text, rating } = this.props;

    // divide by 20, since we want to map the number float [0-100] to 5 possible integer values
    // since max = 100 / 20 = 5, so we get a range from [0-5]
    // const numOfCheckboxes = Math.round(rating / 20);

    // rating must be within bounds of [0-5]
    const numOfCheckboxes = Math.min(Math.max(rating, 0), 5);

    return (
      <span>
        <RatingCheckbox value={1} checked={numOfCheckboxes >= 1} />
        <RatingCheckbox value={2} checked={numOfCheckboxes >= 2} />
        <RatingCheckbox value={3} checked={numOfCheckboxes >= 3} />
        <RatingCheckbox value={4} checked={numOfCheckboxes >= 4} />
        <RatingCheckbox value={5} checked={numOfCheckboxes >= 5} />
        <span>{text}</span>
      </span>
    );
  }
}

export default Rating;
